import { ngxMenuItem } from "projects/sepidz-web-framework/src/lib/models/ngxMenuItem";
import { RoleListComponent } from "src/app/gnr/role/role-list/role-list.component";
import { UserListComponent } from "src/app/gnr/user/user-list/user-list.component";
import { ResetPasswordListComponent } from "src/app/gnr/resetpassword/resetpassword-list.component";
import { Permission } from "projects/sepidz-web-framework/src/lib/models";
import { ProvinceListComponent } from "src/app/gnr/province/province-list/province-list.component";
import { CityListComponent } from "src/app/gnr/city/city-list/city-list.component";
import { FiscalYearListComponent } from "src/app/gnr/fiscal-year/fiscal-year-list/fiscal-year-list.component";
import { MissetupComponent } from "src/app/gnr/missetup/missetup.component";
import { CompanyListComponent } from "../gnr/company/company-list/company-list.component";
import { BranchListComponent } from "../gnr/branch/branch-list/branch-list.component";
import { ZoneListComponent } from "src/app/frontoffice/parties/zone/zone-list.component";
import { CustomerCategoryListComponent } from "src/app/frontoffice/parties/customer-category/customer-category-list.component";
import { CustomerListComponent } from "src/app/frontoffice/parties/customer/customer-list.component";
import { PersonnelListComponent } from "src/app/frontoffice/parties/personnel/personnel-list.component";
import { ItemCategoryListComponent } from "src/app/frontoffice/catalog/item-category-list/item-category-list.component";
import { MeasurementUnitListComponent } from "src/app/frontoffice/catalog/measurement-unit-list/measurement-unit-list.component";
import { SalePriceTypeListComponent } from "src/app/frontoffice/catalog/sale-price-type-list/sale-price-type-list.component";
import { ItemListComponent } from "src/app/frontoffice/catalog/item-list/item-list.component";
import { DescriptionListComponent } from "src/app/frontoffice/catalog/description-list/description-list.component";
import { AdditiveListComponent } from "src/app/frontoffice/catalog/additive-list/additive-list.component";
import { SaleMethodListComponent } from "../frontoffice/sales/sale-method/sale-method-list/sale-method-list.component";
import { SaleMethodBranchList } from "src/app/frontoffice/sales/sale-method-branch/sale-method-branch-list/sale-method-branch-list";
import { GroupMessageComponent } from "src/app/frontoffice/messaging/group-message/group-message.component";
import { MessageTemplateListComponent } from "src/app/frontoffice/messaging/message-template/message-template-list/message-template-list.component";
import { MessageListComponent } from "src/app/frontoffice/messaging/message-list/message-list.component";
import { GeneralLedgerListComponent } from "src/app/backoffice/acc/generalledger/generalledger-list.component";
import { GroupLedgerListComponent } from "src/app/backoffice/acc/groupledger/groupledger-list/groupledger-list.component";
import { SubLedgerListComponent } from "src/app/backoffice/acc/subledger/subledger-list/subledger-list.component";
import { AccVoucherListComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-list/accvoucher-list.component";
import { DetailLedgerKindListComponent } from "src/app/backoffice/acc/detailledgerkind/detailledgerkind-list.component";
import { AccVoucherFormComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { DetailLedgerListComponent } from "src/app/backoffice/acc/detailledger/detailledger-list/detailledger-list.component";
import { AccVoucherKindListComponent } from "src/app/backoffice/acc/accvoucherkind/accvoucherkind-list/accvoucherkind-list.component";
import { WarehouseListComponent } from "src/app/backoffice/inv/warehouse/warehouse-list/warehouse-list.component";
import { UnitListComponent } from "src/app/backoffice/inv/unit/unit-list/unit-list.component";
import { InvVoucherKindListComponent } from "src/app/backoffice/inv/inv-voucher-kind/inv-voucher-kind-list/inv-voucher-kind-list.component";
import { GoodsGroupListComponent } from "src/app/backoffice/inv/goods-group/goods-group-list/goods-group-list.component";
import { GoodsListComponent } from "src/app/backoffice/inv/goods/goods-list/goods-list.component";
import { InvBalanceFormComponent } from "src/app/backoffice/inv/inv-balance/inv-balance-form/inv-balance-form.component";
import { PrintPolicyListComponent } from "src/app/frontoffice/prints/print-policy-list/print-policy-list.component";
import { SalonListComponent } from "src/app/frontoffice/salons/salon-list/salon-list.component";
import { OrderPageComponent } from "src/app/frontoffice/order/orderpage/orderpage.component";
import { InvVoucherListComponent } from "../backoffice/inv/invvoucher/invvoucher-list/invvoucher-list.component";
import { AccountReviewComponent } from "src/app/backoffice/acc/report/account-review/account-review.component";
import { InventoryReviewComponent } from "src/app/backoffice/inv/report/inventory-review/inventory-review.component";
import { DashboardComponent } from "src/app/frontoffice/review/dashboard/dashboard.component";
import { SalesReviewComponent } from "src/app/frontoffice/review/sales-review/sales-review.component";
import { CustomerReviewComponent } from "src/app/frontoffice/review/customer-review/customer-review.component";
import { SecurityReviewComponent } from "src/app/frontoffice/review/security-review/security-review.component";
import { TakingOfInventoryListComponent } from "src/app/backoffice/inv/taking-of-inventory/taking-of-inventory-list/taking-of-inventory-list.component";
import { InventoryClosingListComponent } from "src/app/backoffice/inv/inventory-closing/inventory-closing-list/inventory-closing-list.component";
import { SaleReportDesinerComponent } from "src/app/frontoffice/prints/sale-report-desiner/sale-report-desiner.component";
import { DriverAssignmentComponent } from "../frontoffice/driverassignment/driverassignment.component";
import { MovementVoucherComponent } from "../backoffice/acc/movement-voucher/movement-voucher.component";
import { GeneralLedgerVoucherListComponent } from "../backoffice/acc/general-ledger-voucher/general-ledger-voucher-list/general-ledger-voucher-list.component";
import { BarCodeReaderFormatListComponent } from "../gnr/bar-code-reader-format/bar-code-reader-format-list/bar-code-reader-format-list.component";
import { BankListComponent } from "../backoffice/trs/bank/bank-list/bank-list.component";
import { CashListComponent } from "../backoffice/trs/cash/cash-list/cash-list.component";
import { BankBranchListComponent } from "../backoffice/trs/bank-branch/bank-branch-list/bank-branch-list.component";
import { BankAccountListComponent } from "../backoffice/trs/bank-account/bank-account-list/bank-account-list.component";
import { TrsConcernListComponent } from "../backoffice/trs/trs-concern/trs-concern-list/trs-concern-list.component";
import { ChequeBookListComponent } from "../backoffice/trs/cheque-book/cheque-book-list/cheque-book-list.component";
import { TrsVoucherKindListComponent } from "../backoffice/trs/trs-voucher-kind/trs-voucher-kind-list/trs-voucher-kind-list.component";
import { TrsVoucherListComponent } from "../backoffice/trs/trs-voucher/trs-voucher-list/trs-voucher-list.component";
import { TreasuryReviewComponent } from "../backoffice/trs/report/treasury-review/treasury-review.component";
import { AccCloseProfitandLossAccountsListComponent } from "../backoffice/acc/acc-close-profitand-loss-accounts/acc-close-profitand-loss-accounts-list/acc-close-profitand-loss-accounts-list.component";
import { CreateOpeningJournalVoucherListComponent } from "../backoffice/acc/create-opening-journal-voucher/create-opening-journal-voucher-list/create-opening-journal-voucher-list.component";
import { CreateClosingJournalVoucherListComponent } from "../backoffice/acc/create-closing-journal-voucher/create-closing-journal-voucher-list/create-closing-journal-voucher-list.component";
import { ControlContraryNatureAccountListComponent } from "../backoffice/acc/control-contrary-nature-account/control-contrary-nature-account-list/control-contrary-nature-account-list.component";
import { InvBalanceListComponent } from "../backoffice/inv/inv-balance/inv-balance-list/inv-balance-list.component";
import { InvVoucherPricingListComponent } from "../backoffice/inv/inv-voucher-pricing/inv-voucher-pricing-list/inv-voucher-pricing-list.component";
import { InvNoReferenceVoucherFormComponent } from "../backoffice/inv/report/inv-no-reference-voucher/inv-no-reference-voucher-form.component";
import { DriverSettlementListComponent } from "../frontoffice/financial/driversettlement/driversettlement-list/driversettlement-list.component";
import { PaymentMethodListComponent } from "../frontoffice/financial/paymentmethod/payment-method-list/payment-method-list.component";
import { CasheirSettlementListComponent } from "../frontoffice/financial/driversettlement/cashiersettlement-list/casheirsettlement-list.component";
import { SellCustomerListComponent } from "../backoffice/sell/sell-customer/sell-customer-list/sell-customer-list.component";
import { SellKindListComponent } from "../backoffice/sell/sell-kind/sell-kind-list/sell-kind-list.component";
import { SellCustomerGroupListComponent } from "../backoffice/sell/sell-customer-group/sell-customer-group-list/sell-customer-group-list.component";
import { PriceListHeaderListComponent } from "../backoffice/sell/price-list-header/price-list-header-list/price-list-header-list.component";
import { SellVoucherKindListComponent } from "../backoffice/sell/sell-voucher-kind/sell-voucher-kind-list/sell-voucher-kind-list.component";
import { SellVoucherListComponent } from "../backoffice/sell/sell-voucher/sell-voucher-list/sell-voucher-list.component";
import { CustomerReceiptPaymentListComponent } from "../frontoffice/financial/customer-receipt-payment/customer-receipt-payment-list/customer-receipt-payment-list.component";
import { DataCenterProcessListComponent } from "../gnr/data-center-process/data-center-process-list/data-center-process-list.component";
import { LocalSettingListComponent } from "../frontoffice/local-setting/local-setting-list/local-setting-list.component";
import { OrganizationalUnitListComponent } from "../backoffice/hrm/base-info/organizational-unit/organizational-unit-list/organizational-unit-list.component";
import { JobClassificationListComponent } from "../backoffice/hrm/base-info/job-classification/job-classification-list/job-classification-list.component";
import { JobsListComponent } from "../backoffice/hrm/base-info/jobs/jobs-list/jobs-list.component";
import { EmploymentKindListComponent } from "../backoffice/hrm/base-info/employment-kind/employment-kind-list/employment-kind-list.component";
import { WorkplaceListComponent } from "../backoffice/hrm/base-info/workplace/workplace-list/workplace-list.component";
import { JobGroupListComponent } from "../backoffice/hrm/payment-system/job-group/job-group-list/job-group-list.component";
import { JobBaseListComponent } from "../backoffice/hrm/payment-system/job-base/job-base-list/job-base-list.component";
import { JobRankingListComponent } from "../backoffice/hrm/payment-system/job-ranking/job-ranking-list/job-ranking-list.component";
import { PayCompaniesListComponent } from "../backoffice/hrm/base-info/pay-companies/pay-companies-list/pay-companies-list.component";
import { CitizenshipKindListComponent } from "../backoffice/hrm/reference-lists/citizenship-kind/citizenship-kind-list/citizenship-kind-list.component";
import { NationalityKindListComponent } from "../backoffice/hrm/reference-lists/nationality-kind/nationality-kind-list/nationality-kind-list.component";
import { ReligionKindListComponent } from "../backoffice/hrm/reference-lists/religion-kind/religion-kind-list/religion-kind-list.component";
import { FaithKindListComponent } from "../backoffice/hrm/reference-lists/faith-kind/faith-kind-list/faith-kind-list.component";
import { MartyrFamilayKindListComponent } from "../backoffice/hrm/reference-lists/martyr-familay-kind/martyr-familay-kind-list/martyr-familay-kind-list.component";
import { VeteranWorkShiftKindListComponent } from "../backoffice/hrm/reference-lists/veteran-work-shift-kind/veteran-work-shift-kind-list/veteran-work-shift-kind-list.component";
import { CourseTitleListComponent } from "../backoffice/hrm/reference-lists/course-title/course-title-list/course-title-list.component";
import { LanguageKindListComponent } from "../backoffice/hrm/reference-lists/language-kind/language-kind-list/language-kind-list.component";
import { FluencyInReadingTheLanguageListComponent } from "../backoffice/hrm/reference-lists/fluency-in-reading-the-language/fluency-in-reading-the-language-list/fluency-in-reading-the-language-list.component";
import { ProficiencyInWritingListComponent } from "../backoffice/hrm/reference-lists/proficiency-in-writing/proficiency-in-writing-list/proficiency-in-writing-list.component";
import { FluencyInLanguageConversationListComponent } from "../backoffice/hrm/reference-lists/fluency-in-language-conversation/fluency-in-language-conversation-list/fluency-in-language-conversation-list.component";
import { EducationDegreeListComponent } from "../backoffice/hrm/reference-lists/education-degree/education-degree-list/education-degree-list.component";
import { FieldOfStudyListComponent } from "../backoffice/hrm/reference-lists/field-of-study/field-of-study-list/field-of-study-list.component";
import { AcademicOrientationListComponent } from "../backoffice/hrm/reference-lists/academic-orientation/academic-orientation-list/academic-orientation-list.component";
import { ReasonForDismissalListComponent } from "../backoffice/hrm/reference-lists/reason-for-dismissal/reason-for-dismissal-list/reason-for-dismissal-list.component";
import { RetirementKindListComponent } from "../backoffice/hrm/reference-lists/retirement-kind/retirement-kind-list/retirement-kind-list.component";
import { TaxGroupListComponent } from "../backoffice/hrm/reference-lists/tax-group/tax-group-list/tax-group-list.component";
import { ElementListComponent } from "../backoffice/hrm/base-info/element/element-list/element-list.component";
import { OrganizationalPostsListComponent } from "../backoffice/hrm/base-info/organizational-posts/organizational-posts-list/organizational-posts-list.component";
import { HrmLoanToPersonnelListComponent } from "../backoffice/hrm/loan/hrm-loan-to-personnel-list/hrm-loan-to-personnel-list.component";
import { HrmTaxTableListComponent } from "../backoffice/hrm/base-info/hrm-tax-table/hrm-tax-table-list/hrm-tax-table-list.component";
import { HrmWorkCalendarListComponent } from "../backoffice/hrm/base-info/hrm-work-calendar/hrm-work-calendar-list/hrm-work-calendar-list.component";
import { CostCenterListComponent } from "../backoffice/hrm/base-info/cost-center/cost-center-list/cost-center-list.component";
import { ProjectListComponent } from "../backoffice/hrm/base-info/project/project-list/project-list.component";
import { HrmLoanKindListComponent } from "../backoffice/hrm/loan/hrm-loan-kind/hrm-loan-kind-list/hrm-loan-kind-list.component";
import { HrmPersonnelListComponent } from "../backoffice/hrm/hrm-personnel/hrm-personnel-list/hrm-personnel-list.component";
import { HRNotificationKindListComponent } from "../backoffice/hrm/base-info/hrnotification-kind/hrnotification-kind-list/hrnotification-kind-list.component";
import { HRNotificationHeaderListComponent } from "../backoffice/hrm/hrnotification-header/hrnotification-header-list/hrnotification-header-list.component";
import { FinanceNotificationHeaderListComponent } from "../backoffice/hrm/finance-notification-header/finance-notification-header-list/finance-notification-header-list.component";
import { MonthlySalaryCalculationInformationComponent } from "../backoffice/hrm/monthly-salary-calculation-information/monthly-salary-calculation-information/monthly-salary-calculation-information.component";
import { MonthlyWorkInformationComponent } from "../backoffice/hrm/monthly-work-information/monthly-work-information/monthly-work-information.component";
import { HrmMapReportListComponent } from "../backoffice/hrm/base-info/hrm-map-report/hrm-map-report-list/hrm-map-report-list.component";
import { PayMVPersReportComponent } from "../backoffice/hrm/report/pay-mvpers-report/pay-mvpers-report.component";
import { HrmReviewComponent } from "../backoffice/hrm/report/hrm-review/hrm-review.component";
import { MessageManagementTelephoneListComponent } from "../frontoffice/messaging/message-management-telephone/message-management-telephone-list/message-management-telephone-list.component";
import { ManagementMessageListComponent } from "../frontoffice/messaging/management-message/management-message-list/management-message-list.component";
import { UserSystemLogListComponent } from "../gnr/user-system-log/user-system-log-list/user-system-log-list.component";
import { HrmBankAccountListComponent } from "../backoffice/hrm/base-info/hrm-bank-account/hrm-bank-account-list/hrm-bank-account-list.component";
import { HrmBankListComponent } from "../backoffice/hrm/base-info/hrm-bank/hrm-bank-list/hrm-bank-list.component";
import { CostGroupListComponent } from "../frontoffice/cost/costgroup/costgroup-list/costgroup-list.component";
import { CostListComponent } from "../frontoffice/cost/cost/cost-list/cost-list.component";
import { CostSpentListComponent } from "../frontoffice/cost/spentcost/costspent-list/costspent-list.component";
import { Injectable } from "@angular/core";
import { PeopleInfoListComponent } from "../gnr/people-info/peopleInfo-list.component";
import { ZonePriceAnnouncementListComponent } from "../frontoffice/parties/zone-price-announcement/zone-price-announcement-list/zone-price-announcement-list.component";
import { SellCustomerReviewComponent } from "../backoffice/sell/report/sell-customer-review/sell-customer-review.component";
import { DebtorCreditorNoticesHeaderListComponent } from "../backoffice/sell/debtor-creditor-notices-header/debtor-creditor-notices-header-list/debtor-creditor-notices-header-list.component";
import { ItemPriceChangeListComponent } from "../frontoffice/catalog/item-price-change/item-price-change-list/item-price-change-list.component";
import { HrmInsuranceReportComponent } from "../backoffice/hrm/report/hrm-insurance-report/hrm-insurance-report.component";
import { HrmTaxReportComponent } from "../backoffice/hrm/report/hrm-tax-report/hrm-tax-report.component";
import { BillPayReportComponent } from "../backoffice/hrm/report/bill-pay-report/bill-pay-report.component";
import { HrmInsuranceDskComponent } from "../backoffice/hrm/report/hrm-insurance-disk/hrm-insurance-disk.component";
import { HrmDiskFormatListComponent } from "../backoffice/hrm/report/hrm-disk-format/hrm-disk-format-list/hrm-disk-format-list.component";
import { TaxPayerSystemListComponent } from "../frontoffice/TaxPayerSystem/TaxPayerSystem-list/TaxPayerSystem-list.component";
import { AccountingSettingListComponent } from "../frontoffice/financial/accounting-setting/accounting-setting-list/accounting-setting-list.component";
import { DeliveredComponent } from "../frontoffice/order/delivered/delivered.component";
import { CostsSpentReviewComponent } from "../frontoffice/review/costs-spent-review/costs-spent-review.component";
import { HrmAccVoucherCodeComponent } from "../backoffice/hrm/acc-voucher/hrm-acc-voucher-code/hrm-acc-voucher-code.component";
import { HrmAccVoucherComponent } from "../backoffice/hrm/acc-voucher/hrm-acc-voucher/hrm-acc-voucher.component";
import { HrmAccVoucherHeaderComponent } from "../backoffice/hrm/acc-voucher/hrm-acc-voucher-header/hrm-acc-voucher-header.component";
import { ConnectOnlineMenuComponent } from "../frontoffice/portal/connect-online-menu/connect-online-menu.component";
import { HrmPersonnelElementInitialComponent } from "../backoffice/hrm/hrm-personnel-element-initial/hrm-personnel-element-initial.component";
import { ProductConversionListComponent } from "../backoffice/inv/product-conversion/product-conversion-form/product-conversion-list/product-conversion-list.component";
import { ProductConversionStandardListComponent } from "../backoffice/inv/product-conversion/product-conversion-standard-form/product-conversion-standard-list/product-conversion-standard-list.component";
import { InvDailyRemainListComponent } from "../frontoffice/inv/inv-daily-remain/inv-daily-remain-list/inv-daily-remain-list.component";
import { InvDailyWasteListComponent } from "../frontoffice/inv/inv-daily-waste/inv-daily-waste-list/inv-daily-waste-list.component";
import { InvDailyListComponent } from "../frontoffice/inv/inv-daily-header/inv-daily-list/inv-daily-list.component";
import { InvDailyWarehouseComponent } from "../frontoffice/inv/inv-daily-warehouse/inv-daily-warehouse.component";
import { InvCreateInvVoucherListComponent } from "../frontoffice/inv/inv-CreateInvVoucher/inv-CreateInVoucher-list/inv-CreateInvVoucher-list.component";
import { InvDailyBalanceComponent } from "../frontoffice/inv/inv-daily-balance/inv-daily-balance.component";
import { RahkaranListComponent } from "../frontoffice/portal/rahkaran/rahkaran-list/rahkaran-list.component";
import { WarehouseGoodsReportComponent } from "../backoffice/inv/report/warehouse-goods-report/warehouse-goods-report.component";
import { RahkaranSettingComponent } from "../frontoffice/portal/rahkaran/rahkaran-setting/rahkaran-setting.component";
import { AccountingDocumentListComponent } from "../frontoffice/financial/accounting-document/accounting-document-list/accounting-document-list.component";
import { AccBalanceSheetComponent } from "../backoffice/acc/report/balance-sheet/acc-balance-sheet.component";
import { AccBalance4Component } from "../backoffice/acc/report/aa-balce4/acc-balance-4.component";
import { AccBalance6Component } from "../backoffice/acc/report/aa-balce6/acc-balance-6.component";
import { AccBalance8Component } from "../backoffice/acc/report/aa-balce8/acc-balance-8.component";
import { AccDetailLedegerSubledgerBalancSheetComponent } from "../backoffice/acc/report/detail-ledeger-subledger-balanc-sheet/detail-ledeger-subledger-balanc-sheet.component";
import { AccBalanceSheetCompareWithPrevYearComponent } from "../backoffice/acc/report/balance-sheet-compare-with-prev-year/balance-sheet-compare-with-prev-year.component";
import { AccBalanceSheetCompareWithPrevYearSubLedgerFilterdByDetailLedgerComponent } from "../backoffice/acc/report/balance-sheet-compare-prev-year-subledger-filterd-by-detailLedger/balance-sheet-compare-prev-year-subledger-filterd-by-detailLedger.component";
import { AccBalanceSheetCompareWithPrevYearGeneralLedgerFilterdByDetailLedgerComponent } from "../backoffice/acc/report/balance-sheet-compare-prev-year-generalledger-filterd-by-detailLedger/balance-sheet-compare-prev-year-generalledger-filterd-by-detailLedger.component";
import { GeneralLedgerVoucherComponent } from "../backoffice/acc/report/general-ledger-voucher/general-ledger-voucher.component";
import { GeneralLedgerDailyVoucherComponent } from "../backoffice/acc/report/general-ledger-daily-voucher/general-ledger-daily-voucher.component";
import { MaterialUseInProductReportComponent } from "../backoffice/inv/report/material-use-in-product-report/material-use-in-product-report.component";
import { PurchaseInvoiceReportComponent } from "../backoffice/inv/report/purchase-invoice-report/purchase-invoice-report.component";
import { PriceChangeInPurchaseReportComponent } from "../backoffice/inv/report/price-change-in-purchase-report/price-change-in-purchase-report.component";
import { FinishedPriceOfProductsBeforeSaleReportComponent } from "../backoffice/inv/report/finished-price-of-products-before-sale-report/finished-price-of-products-before-sale-report.component";
import { CirculationOfGoodsReportComponent } from "../backoffice/inv/report/circulation-of-goods-report/circulation-of-goods-report.component";
import { CostPriceOfManufacturedProductsReportComponent } from "../backoffice/inv/report/cost-price-of-manufactured-products-report/cost-price-of-manufactured-products-report.component";
import { InvDailyUsageComponent } from "../frontoffice/inv/inv-daily-usage/inv-daily-usage.component";
import { GeneralMonthlyFoodCostReportComponent } from "../backoffice/inv/report/general-monthly-food-cost-report/general-monthly-food-cost-report.component";
import { NewDailyPurchaseInvoiceReportComponent } from "../backoffice/inv/report/new-daily-purchase-invoice-Report/new-daily-purchase-invoice-Report.component";
import { PurchaseReportWithTaxComponent } from "../backoffice/inv/report/purchase-report-with-tax/purchase-report-with-tax.component";
import { NegativeRemainOfGoodsDalyReportComponent } from "../backoffice/inv/report/negative-remain-of-goods-daly-report/negative-remain-of-goods-daly-report.component";
import { AverageGoodsReportComponent } from "../backoffice/inv/report/average-goods-report/average-goods-report.component";
import { CheckBookComponent } from "../backoffice/trs/report/check-book/check-book.component";
import { GeneralLedgerVoucherDocumentComponent } from "../backoffice/acc/report/general-ledger-voucher-document/general-ledger-voucher-document.component";
import { GeneralLedgerDailyVoucherDocumentComponent } from "../backoffice/acc/report/general-ledger-daily-voucher-document/general-ledger-daily-voucher-document.component";
import { OrderReviewComponent } from "../frontoffice/review/order-review/order-review.component";

@Injectable()
export class MenuService {
  MENU_ITEMS: ngxMenuItem[] = [
    {
      title: "ClientApp.Pages.PageMenu.Information",
      icon: "icon-information",
      children: [
        {
          title: "ClientApp.Pages.PageMenu.MissSetup",
          icon: "icon-settings-o1",
          link: "/",
          data: MissetupComponent,
          apiName: "General:MisSetUp",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.BarCode",
          icon: "icon-qr_code-o",
          link: "/",
          data: BarCodeReaderFormatListComponent,
          apiName: "General:BarCodeReaderFormat",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.Company",
          icon: "icon-add_business-o",
          link: "/",
          data: CompanyListComponent,
          apiName: "General:Company",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.Branch",
          icon: "icon-account_tree-o",
          link: "/",
          data: BranchListComponent,
          apiName: "General:Branch",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.IntroductionPersons",
          icon: "icon-group_add-o",
          link: "/",
          data: PeopleInfoListComponent,
          apiName: "General:PeopleInfo",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.DataCenteProcecss",
          icon: "icon-branch",
          link: "/",
          data: DataCenterProcessListComponent,
          apiName: "General:DataCenterProcess",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.Province",
          icon: "icon-location-mark",
          link: "/",
          data: ProvinceListComponent,
          apiName: "General:Province",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.City",
          icon: "icon-business-o",
          link: "/",
          data: CityListComponent,
          apiName: "General:City",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.FiscalYear",
          icon: "icon-date_range-o",
          link: "/",
          data: FiscalYearListComponent,
          apiName: "General:FiscalYear",
          actionName: Permission.viewPermission,
        },
      ],
    },
    {
      title: "ClientApp.Pages.PageMenu.Sale",
      icon: "icon-sale",
      children: [
        {
          title: "ClientApp.Pages.PageMenu.SaleSetting",
          icon: "icon-info-24px",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.Group",
              icon: "icon-group-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.Personnel",
                  link: "/",
                  icon: "icon-person_outline-F",
                  data: PersonnelListComponent,
                  apiName: "RestaurantSale:Personnel",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Zone",
                  link: "/",
                  icon: "icon-business-o",
                  data: ZoneListComponent,
                  apiName: "RestaurantSale:Zone",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.CustomerCategory",
                  link: "/",
                  icon: "icon-groups-o",
                  data: CustomerCategoryListComponent,
                  apiName: "RestaurantSale:CustomerCategory",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Customer",
                  link: "/",
                  icon: "icon-group_add-o",
                  data: CustomerListComponent,
                  apiName: "RestaurantSale:Customer",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ZonePriceAnnouncement",
                  link: "/",
                  icon: "icon-group_add-o",
                  data: ZonePriceAnnouncementListComponent,
                  apiName: "RestaurantSale:Customer",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.ItemTitle",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.ItemCategory",
                  link: "/",
                  icon: "icon-cube-scan",
                  data: ItemCategoryListComponent,
                  apiName: "RestaurantSale:ItemCategory",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Item",
                  link: "/",
                  icon: "icon-cube-outline",
                  data: ItemListComponent,
                  apiName: "RestaurantSale:Item",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Additive",
                  link: "/",
                  icon: "icon-library_add-o",
                  data: AdditiveListComponent,
                  apiName: "RestaurantSale:Additive",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Description",
                  link: "/",
                  icon: "icon-gamepad-round-outline",
                  data: DescriptionListComponent,
                  apiName: "RestaurantSale:Description",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.UnitList",
                  link: "/",
                  icon: "icon-scale",
                  data: MeasurementUnitListComponent,
                  apiName: "RestaurantSale:MeasurementUnit",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SalePriceType",
                  link: "/",
                  icon: "icon-payments-o",
                  data: SalePriceTypeListComponent,
                  apiName: "RestaurantSale:SalePriceType",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ItemPriceChange",
                  link: "/",
                  icon: "icon-payments-o",
                  data: ItemPriceChangeListComponent,
                  apiName: "RestaurantSale:ItemPriceChange",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.StructualSale",
              icon: "icon-widgets-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.Salon",
                  icon: "icon-deck-o",
                  link: "/",
                  data: SalonListComponent,
                  apiName: "RestaurantSale:Salon",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.PaymentMethod",
                  icon: "icon-sell-selling",
                  link: "/",
                  data: PaymentMethodListComponent,
                  apiName: "RestaurantSale:PaymentMethod",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SaleMethod",
                  icon: "icon-content-copy",
                  link: "/",
                  data: SaleMethodListComponent,
                  apiName: "RestaurantSale:SaleMethod",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SaleMethodBranchId",
                  icon: "icon-layers-o",
                  link: "/",
                  data: SaleMethodBranchList,
                  apiName: "RestaurantSale:SaleMethodBranch",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.LocalSetting",
                  icon: "icon-layers-o",
                  link: "/",
                  data: LocalSettingListComponent,
                  apiName: "RestaurantSale:LocalSetting",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.Costs",
              icon: "icon-cash-multiple",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.CostGroup",
                  icon: "icon-print-o",
                  link: "/",
                  data: CostGroupListComponent,
                  apiName: "RestaurantSale:CostGroup",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Cost",
                  icon: "icon-insights-o",
                  link: "/",
                  data: CostListComponent,
                  apiName: "RestaurantSale:Cost",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.DailyTitle",
          icon: "icon-note_add-o",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.SaleTitle",
              name: "RestaurantSale:Invoice",
              icon: "icon-shopping_basket-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.SaleMethodBranch",
                  icon: "icon-table",
                  link: "/",
                  data: OrderPageComponent,
                  apiName: "RestaurantSale:SaleMethodBranch",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.Delivered",
              icon: "icon-waiter",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.DeliveredFood",
                  link: "/",
                  icon: "icon-payments-o",
                  data: DeliveredComponent,
                  apiName: "RestaurantSale:SaleMethodBranch",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.AssignmentTitle",
              icon: "icon-note_add-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.DriverAssignment",
                  icon: "icon-moped-o",
                  link: "/",
                  data: DriverAssignmentComponent,
                  apiName: "RestaurantSale:DriverAssignment",
                  actionName: Permission.viewPermission,
                },
              ],
            },

            {
              title: "ClientApp.Pages.PageMenu.PaymentTitle",
              icon: "icon-payment-o seticon",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.DriverSettlement",
                  icon: "icon-cash-on-delivery",
                  link: "/",
                  data: DriverSettlementListComponent,
                  apiName: "RestaurantSale:DriverSettlement",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.CashierSettlemet",
                  icon: "icon-cash-multiple",
                  link: "/",
                  data: CasheirSettlementListComponent,
                  apiName: "RestaurantSale:CashierSettlemet",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.CustomerSettlemet",
                  icon: "icon-account_balance_wallet-o",
                  link: "/",
                  data: CustomerReceiptPaymentListComponent,
                  apiName: "RestaurantSale:CustomerSettlemet",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.CostSpent",
              icon: "icon-cash",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.CostSpent",
                  icon: "icon-insights-o",
                  link: "/",
                  data: CostSpentListComponent,
                  apiName: "RestaurantSale:CostSpent",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.TaxPayerSystem",
              icon: "icon-note_add-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.TaxPayerSystem",
                  icon: "icon-moped-o",
                  link: "/",
                  data: TaxPayerSystemListComponent,
                  apiName: "RestaurantSale:TaxPayer",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.SmsTitle",
          icon: "icon-forum-o",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.MessageTemplate",
              link: "/",
              icon: "icon-chat-o",
              data: MessageTemplateListComponent,
              apiName: "RestaurantSale:MessageTemplate",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.Message",
              link: "/",
              icon: "icon-library_add-o",
              data: GroupMessageComponent,
              apiName: "RestaurantSale:Message",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.ReadMessageList",
              link: "/",
              icon: "icon-chat_bubble_outline-o",
              data: MessageListComponent,
              apiName: "RestaurantSale:Message/ReadMessageList",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.ManagementPhones",
              link: "/",
              icon: "icon-chat_bubble_outline-o",
              data: MessageManagementTelephoneListComponent,
              apiName: "RestaurantSale:MessageManagementTelephone",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.ManagementMessage",
              link: "/",
              icon: "icon-chat_bubble_outline-o",
              data: ManagementMessageListComponent,
              apiName: "RestaurantSale:ManagementMessage",
              actionName: Permission.viewPermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.PrintPolicyTitle",
          icon: "icon-print-o",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.PrintPolicy",
              icon: "icon-print-o",
              link: "/",
              data: PrintPolicyListComponent,
              apiName: "RestaurantSale:PrintPolicy",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.PrintTemplate",
              icon: "icon-insights-o",
              link: "/",
              data: SaleReportDesinerComponent,
              apiName: "RestaurantSale:PrintPolicy",
              actionName: Permission.viewPermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.BalanceTitle",
          icon: "icon-anbar2",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.InvDailyWarehouse",
              icon: "icon-fact_check-o",
              link: "/",
              data: InvDailyWarehouseComponent,
              apiName: "RestaurantSale:InvDailyHeader",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.InvDailyHeader",
              icon: "icon-image_aspect_ratio-o",
              link: "/",
              data: InvDailyListComponent,
              apiName: "RestaurantSale:InvDailyHeader",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.InvDailyRemain",
              icon: "icon-image_aspect_ratio-o",
              link: "/",
              data: InvDailyRemainListComponent,
              apiName: "RestaurantSale:InvDailyRemain",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.InvDailyWaste",
              icon: "icon-image_aspect_ratio-o",
              link: "/",
              data: InvDailyWasteListComponent,
              apiName: "RestaurantSale:InvDailyWaste",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.InvCreateInvVoucher",
              icon: "icon-text-box-outline",
              link: "/",
              data: InvCreateInvVoucherListComponent,
              apiName: "RestaurantSale:InvCreateInvVoucher",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.InvDailyBalance",
              icon: "icon-text-box-outline",
              link: "/",
              data: InvDailyBalanceComponent,
              apiName: "RestaurantSale:InvDailyBalance",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.UseOfIngredients",
              icon: "icon-text-box-outline",
              link: "/",
              data: InvDailyUsageComponent,
              apiName: "RestaurantSale:MaterialUseInProduct",
              actionName: Permission.viewPermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.SaleReportTitle",
          icon: "icon-chart-bar-stacked",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.SaleReview",
              icon: "icon-chart-bell-curve",
              link: "/",
              data: SalesReviewComponent,
              apiName: "RestaurantSale:SaleReview",
              actionName: Permission.viewPermission,
              VoucherKindId: 1,
            },
            {
              title: "ClientApp.Pages.PageMenu.CustomerReview",
              icon: "icon-chart-bell-curve-cumulative",
              link: "/",
              data: CustomerReviewComponent,
              apiName: "RestaurantSale:CustomerReview",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.SecurityReview",
              icon: "icon-chart-multiple",
              link: "/",
              data: SecurityReviewComponent,
              apiName: "RestaurantSale:SecurityReview",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.CostsSpentReview",
              icon: "icon-chart-multiple",
              link: "/",
              data: CostsSpentReviewComponent,
              apiName: "RestaurantSale:CostsSpentReview",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.DepositReview",
              icon: "icon-chart-multiple",
              link: "/",
              data: OrderReviewComponent,
              apiName: "RestaurantSale:OrderReview",
              actionName: Permission.viewPermission,
              VoucherKindId: 2,
            },
            {
              title: "ClientApp.Pages.PageMenu.Dashboard",
              link: "/",
              icon: "icon-dashboard-o1",
              data: DashboardComponent,
              apiName: "RestaurantSale:Dashboard",
              actionName: Permission.viewPermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.PortalTitle",
          icon: "icon-sitemap1",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.OnlineMenu",
              icon: "icon-sitemap1",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.ConnectOnlineMenu",
                  icon: "icon-menu_book-F",
                  link: "/",
                  data: ConnectOnlineMenuComponent,
                  apiName: "RestaurantSale:Peripheral",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.RahkaranTitle",
              icon: "icon-sitemap1",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.Rahkaran",
                  icon: "icon-menu_book-F",
                  link: "/",
                  data: RahkaranListComponent,
                  apiName: "RestaurantSale:Rahkaran",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.RahkaranSetting",
                  icon: "icon-menu_book-F",
                  link: "/",
                  data: RahkaranSettingComponent,
                  apiName: "RestaurantSale:RahkaranSetting",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.Accounting",
              icon: "icon-sitemap1",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.AccDocumentVoucherTitle",
                  icon: "icon-menu_book-F",
                  link: "/",
                  data: AccountingDocumentListComponent,
                  apiName: "RestaurantSale:Peripheral",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.AccDocumentVoucherSetting",
                  link: "/",
                  icon: "icon-accounting",
                  data: AccountingSettingListComponent,
                  apiName: "RestaurantSale:SaleAccountingSetting",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
      ],
    },

    {
      title: "ClientApp.Pages.PageMenu.AccountingSubTitle",
      icon: "icon-aounting",
      children: [
        {
          title: "ClientApp.Pages.PageMenu.AccountingBasicInformation",
          icon: "icon-info-24px",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.AccountingBasicInformation",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.GroupLedger",
                  link: "/",
                  icon: "",
                  data: GroupLedgerListComponent,
                  apiName: "Accounting:GroupLedger",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.GeneralLedger",
                  link: "/",
                  icon: "",
                  data: GeneralLedgerListComponent,
                  apiName: "Accounting:GeneralLedger",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SubLedger",
                  link: "/",
                  icon: "",
                  data: SubLedgerListComponent,
                  apiName: "Accounting:SubLedger",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.DetailLedgerKind",
                  link: "/",
                  icon: "",
                  data: DetailLedgerKindListComponent,
                  apiName: "Accounting:DetailLedgerKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.DetailLedger",
                  link: "/",
                  icon: "",
                  data: DetailLedgerListComponent,
                  apiName: "Accounting:DetailLedger",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.AccVoucherKind",
                  link: "/",
                  icon: "",
                  data: AccVoucherKindListComponent,
                  apiName: "Accounting:AccVoucherKind",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.AccVoucherTitle",
          icon: "icon-library_books-o",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.AccVoucherTitle",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.AccVoucherHeader",
                  link: "/",
                  icon: "",
                  data: AccVoucherFormComponent,
                  VoucherKindId: 1,
                  apiName: "Accounting:AccVoucherHeader",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.MovementVoucher",
                  link: "/",
                  //icon:'account-outline',
                  data: MovementVoucherComponent,
                  apiName: "Accounting:AccVoucherHeader/MovementVoucher",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.GeneralLedgerVoucherHeader",
                  link: "/",
                  //icon:'account-outline',
                  data: GeneralLedgerVoucherListComponent,
                  apiName: "Accounting:GeneralLedgerVoucherHeader",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.AccVoucherList",
                  link: "/",
                  //icon:'account-outline',
                  data: AccVoucherListComponent,
                  apiName: "Accounting:AccVoucherHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.EndOfOpration",
          // icon: { icon:'users', pack:'sepidzicon'},
          icon: "icon-calendar-end",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.EndOfOpration",
              icon: "icon-calendar-end",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.AccCloseProfitandLossAccountsHeader",
                  link: "/",
                  //icon:'account-outline',
                  data: AccCloseProfitandLossAccountsListComponent,
                  apiName: "Accounting:AccCloseProfitandLossAccountsHeader",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.CreateClosingJournalVoucher",
                  link: "/",
                  //icon:'account-outline',
                  data: CreateClosingJournalVoucherListComponent,
                  apiName: "Accounting:AccCloseProfitandLossAccountsHeader/CreateClosingJournalVoucher",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.CreateOpeningJournalVoucher",
                  link: "/",
                  //icon:'account-outline',
                  data: CreateOpeningJournalVoucherListComponent,
                  apiName: "Accounting:AccCloseProfitandLossAccountsHeader/CreateOpeningJournalVoucher",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.GetControlContraryNatureAccountDetail",
                  link: "/",
                  //icon:'account-outline',
                  data: ControlContraryNatureAccountListComponent,
                  apiName: "Accounting:AccCloseProfitandLossAccountsHeader/GetControlContraryNatureAccountDetail",
                  actionName: Permission.samePermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.AccReportTitle",
          icon: "icon-chart-bar-stacked",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.AccReportTitle",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.AccountReview",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: AccountReviewComponent,
                  apiName: "Accounting:AccountReview",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.balanceSheet",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: AccBalanceSheetComponent,
                  apiName: "Accounting:AccountReview/GetAccBalanceSheet",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.FourColumnTrialBalance",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: AccBalance4Component,
                  apiName: "Accounting:AccountReview/GetAccBalance4",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SixColumnTrialBalance",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: AccBalance6Component,
                  apiName: "Accounting:AccountReview/GetAccBalance6",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.EightColumnTrialBalance",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: AccBalance8Component,
                  apiName: "Accounting:AccountReview/GetAccBalance8",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.DetailedBalanceSpecificDetailedBalanceSheet",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: AccDetailLedegerSubledgerBalancSheetComponent,
                  apiName: "Accounting:AccountReview/GetAccDetailLedegerSubledgerBalancSheet",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ComparativeProfitLossStatement",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: AccBalanceSheetCompareWithPrevYearComponent,
                  apiName: "Accounting:AccountReview/GetAccBalanceSheetCompareWithPrevYear",
                  actionName: Permission.samePermission,
                },
                // {
                //   title: "ClientApp.Pages.PageMenu.ComparativeProfitLossStatementDetailedFilter",
                //   link: "/",
                //   //icon:'icon-fact_check-o',
                //   data: AccBalanceSheetCompareWithPrevYearGeneralLedgerFilterdByDetailLedgerComponent,
                //   apiName: "Accounting:AccountReview/AccBalanceSheetCompareWithPrevYearGeneralLedgerFilterdByDetailLedger",
                //   actionName: Permission.viewPermission,
                // },
                // {
                //   title: "ClientApp.Pages.PageMenu.CertainComparativeProfitLossStatementDetailedFilter",
                //   link: "/",
                //   //icon:'icon-fact_check-o',
                //   data: AccBalanceSheetCompareWithPrevYearSubLedgerFilterdByDetailLedgerComponent,
                //   apiName: "Accounting:AccountReview/AccBalanceSheetCompareWithPrevYearSubledgerFilterdByDetailLedger",
                //   actionName: Permission.viewPermission,
                // },
                {
                  title: "ClientApp.Pages.PageMenu.GeneralOfficeDocument",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: GeneralLedgerVoucherDocumentComponent,
                  apiName: "Accounting:AccountReview/GetGeneralLedgerVoucherDocument",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.GeneralOffice",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: GeneralLedgerVoucherComponent,
                  apiName: "Accounting:AccountReview/GetGeneralLedgerVoucher",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.NewspaperOfficeDocument",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: GeneralLedgerDailyVoucherDocumentComponent,
                  apiName: "Accounting:AccountReview/GetGeneralLedgerDailyVoucherDocument",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.NewspaperOffice",
                  link: "/",
                  //icon:'icon-fact_check-o',
                  data: GeneralLedgerDailyVoucherComponent,
                  apiName: "Accounting:AccountReview/GetGeneralLedgerDailyVoucher",
                  actionName: Permission.samePermission,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: "ClientApp.Pages.PageMenu.TrsSubtitle",
      icon: "icon-khazane",
      children: [
        {
          title: "ClientApp.Pages.PageMenu.TrsBasicInformation",
          icon: "icon-info-24px",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.TrsBasicInformation",
              icon: "icon-group-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.BankList",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: BankListComponent,
                  apiName: "Treasury:Bank",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.CashList",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: CashListComponent,
                  apiName: "Treasury:Cash",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.BankBranchList",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: BankBranchListComponent,
                  apiName: "Treasury:BankBranch",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.BankAccountList",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: BankAccountListComponent,
                  apiName: "Treasury:BankAccount",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.TrsConcernLis",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: TrsConcernListComponent,
                  apiName: "Treasury:TrsConcern",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.TrsVoucherKindList",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: TrsVoucherKindListComponent,
                  apiName: "Treasury:TrsVoucherKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ChequeBookList",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: ChequeBookListComponent,
                  apiName: "Treasury:ChequeBookHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.TrsVoucherDaily",
          name: "Treasury:TrsVoucherHeader",
          icon: "icon-receipt-o",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.TrsVoucherDaily",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.TrsVoucherList",
                  link: "/",
                  //icon:'account-outline',
                  data: TrsVoucherListComponent,
                  apiName: "Treasury:TrsVoucherHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.TrsReviewTitle",
          icon: "icon-cube-outline",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.TrsReviewTitle",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.TreasuryReview",
                  link: "/",
                  //icon:'account-outline',
                  data: TreasuryReviewComponent,
                  apiName: "Treasury:TreasuryReview",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "گزارش دفتر چک",
                  link: "/",
                  //icon:'account-outline',
                  data: CheckBookComponent,
                  apiName: "Treasury:TreasuryReview/GetCheckBook",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: "ClientApp.Pages.PageMenu.Salary",
      icon: "icon-hoqoq",
      children: [
        {
          title: "ClientApp.Pages.PageMenu.BasicInformation",
          icon: "icon-info-24px",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.Organizations",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.OrganizationalUnits",
                  link: "/",
                  icon: "",
                  data: OrganizationalUnitListComponent,
                  apiName: "Payroll:OrganizationalUnit",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.OrganizationalPosts",
                  link: "/",
                  icon: "",
                  data: OrganizationalPostsListComponent,
                  apiName: "Payroll:OrganizationalPosts",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.JobGrouping",
                  link: "/",
                  icon: "",
                  data: JobClassificationListComponent,
                  apiName: "Payroll:JobClassification",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Jobs",
                  link: "/",
                  icon: "",
                  data: JobsListComponent,
                  apiName: "Payroll:Jobs",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.TypesEmployment",
                  link: "/",
                  icon: "",
                  data: EmploymentKindListComponent,
                  apiName: "Payroll:EmploymentKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.PlaceService",
                  link: "/",
                  icon: "",
                  data: WorkplaceListComponent,
                  apiName: "Payroll:Workplace",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.Agents",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.Salary",
                  link: "/",
                  icon: "",
                  VoucherKindId: 6,
                  data: ElementListComponent,
                  apiName: "Payroll:Element",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.EidStock",
                  link: "/",
                  icon: "",
                  VoucherKindId: 7,
                  data: ElementListComponent,
                  apiName: "Payroll:Element",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.EidFee",
                  link: "/",
                  icon: "",
                  VoucherKindId: 8,
                  data: ElementListComponent,
                  apiName: "Payroll:Element",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.VacationSave",
                  link: "/",
                  icon: "",
                  VoucherKindId: 9,
                  data: ElementListComponent,
                  apiName: "Payroll:Element",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.VacationRedemption",
                  link: "/",
                  icon: "",
                  VoucherKindId: 10,
                  data: ElementListComponent,
                  apiName: "Payroll:Element",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ReserveYearsSservice",
                  link: "/",
                  icon: "",
                  VoucherKindId: 11,
                  data: ElementListComponent,
                  apiName: "Payroll:Element",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.PaymentSystem",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.Band",
                  link: "/",
                  icon: "",
                  data: JobGroupListComponent,
                  apiName: "Payroll:JobGroup",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Base",
                  link: "/",
                  icon: "",
                  data: JobBaseListComponent,
                  apiName: "Payroll:JobBase",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Rank",
                  link: "/",
                  icon: "",
                  data: JobRankingListComponent,
                  apiName: "Payroll:JobRanking",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.InsuranceFinanceOrganizationsBranches",
              link: "/",
              icon: "",
              data: PayCompaniesListComponent,
              apiName: "Payroll:PayCompanies",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.ReferenceLists",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.Nationality",
                  link: "/",
                  icon: "",
                  data: CitizenshipKindListComponent,
                  apiName: "Payroll:CitizenshipKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Nationali",
                  link: "/",
                  icon: "",
                  data: NationalityKindListComponent,
                  apiName: "Payroll:NationalityKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Dean",
                  link: "/",
                  icon: "",
                  data: ReligionKindListComponent,
                  apiName: "Payroll:ReligionKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.Religion",
                  link: "/",
                  icon: "",
                  data: FaithKindListComponent,
                  apiName: "Payroll:FaithKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.RelationshipDegreeMartyrFamily",
                  link: "/",
                  icon: "",
                  data: MartyrFamilayKindListComponent,
                  apiName: "Payroll:MartyrFamilayKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.VeteransShift",
                  link: "/",
                  icon: "",
                  data: VeteranWorkShiftKindListComponent,
                  apiName: "Payroll:VeteranWorkShiftKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.StudyCourseTitle",
                  link: "/",
                  icon: "",
                  data: CourseTitleListComponent,
                  apiName: "Payroll:CourseTitle",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.LanguageType",
                  link: "/",
                  icon: "",
                  data: LanguageKindListComponent,
                  apiName: "Payroll:LanguageKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.LanguageReadingProficiency",
                  link: "/",
                  icon: "",
                  data: FluencyInReadingTheLanguageListComponent,
                  apiName: "Payroll:FluencyInReadingTheLanguage",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.WritingMastery",
                  link: "/",
                  icon: "",
                  data: ProficiencyInWritingListComponent,
                  apiName: "Payroll:ProficiencyInWriting",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.CommunityLanguageConversation",
                  link: "/",
                  icon: "",
                  data: FluencyInLanguageConversationListComponent,
                  apiName: "Payroll:FluencyInLanguageConversation",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.StudyPeriod",
                  link: "/",
                  icon: "",
                  data: EducationDegreeListComponent,
                  apiName: "Payroll:EducationDegree",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.FieldStudy",
                  link: "/",
                  icon: "",
                  data: FieldOfStudyListComponent,
                  apiName: "Payroll:FieldOfStudy",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.AcademicOrientation",
                  link: "/",
                  icon: "",
                  data: AcademicOrientationListComponent,
                  apiName: "Payroll:AcademicOrientation",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ReasonDismissal",
                  link: "/",
                  icon: "",
                  data: ReasonForDismissalListComponent,
                  apiName: "Payroll:ReasonForDismissal",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.TypeRetirement",
                  link: "/",
                  icon: "",
                  data: RetirementKindListComponent,
                  apiName: "Payroll:RetirementKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.TaxGroup",
                  link: "/",
                  icon: "",
                  data: TaxGroupListComponent,
                  apiName: "Payroll:TaxGroup",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.CostCenter",
              link: "/",
              icon: "",
              data: CostCenterListComponent,
              apiName: "Payroll:CostCenter",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.ProjectList",
              link: "/",
              icon: "",
              data: ProjectListComponent,
              apiName: "Payroll:Project",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.TaxTable",
              link: "/",
              icon: "",
              data: HrmTaxTableListComponent,
              apiName: "Payroll:HrmTaxTable",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.WorkCalendarTable",
              link: "/",
              icon: "",
              data: HrmWorkCalendarListComponent,
              apiName: "Payroll:HrmWorkCalendar",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.TypesLoans",
              link: "/",
              icon: "",
              data: HrmLoanKindListComponent,
              apiName: "Payroll:HrmLoanKind",
              actionName: Permission.viewPermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.DailyOperations",
          icon: "icon-note_add-o",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.EmployeeList",
              icon: "icon-group-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.EmployeeList",
                  link: "/",
                  icon: "",
                  data: HrmPersonnelListComponent,
                  apiName: "Payroll:HrmPersonnel",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.RecruitmentRules",
              link: "/",
              icon: "icon-group-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.VerdictType",
                  link: "/",
                  icon: "",
                  data: HRNotificationKindListComponent,
                  apiName: "Payroll:HRNotificationKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.IndividualSentence",
                  link: "/",
                  icon: "",
                  data: HRNotificationHeaderListComponent,
                  apiName: "Payroll:HRNotificationHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.FinancialProvisions",
              link: "/",
              icon: "icon-group-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.IndividualSentence",
                  link: "/",
                  icon: "",
                  data: FinanceNotificationHeaderListComponent,
                  apiName: "Payroll:FinanceNotificationHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.EmployeeLoan",
              link: "/",
              icon: "",
              data: HrmLoanToPersonnelListComponent,
              apiName: "Payroll:HrmLoanToPersonnel",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.PaymentLocations",
              link: "/",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.PlacePayment",
                  link: "/",
                  icon: "",
                  data: HrmBankListComponent,
                  apiName: "Payroll:HrmBank",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.LinkingAccountNumberPlacePayment",
                  link: "/",
                  icon: "",
                  data: HrmBankAccountListComponent,
                  apiName: "Payroll:HrmBank",
                  actionName: Permission.viewPermission,
                },
              ],
            },
            {
              title: "ClientApp.Pages.PageMenu.MonthlyInformation",
              link: "/",
              icon: "",
              data: MonthlyWorkInformationComponent,
              apiName: "Payroll:MonthlyWorkInformation",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.AgentDeploymentInformation",
              link: "/",
              icon: "",
              data: HrmPersonnelElementInitialComponent,
              apiName: "Payroll:HrmPersonnelElementInitial",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.Calculation",
              link: "/",
              icon: "icon-cube-outline",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.SalaryCalculation",
                  link: "/",
                  icon: "",
                  VoucherKindId: 6,
                  data: MonthlySalaryCalculationInformationComponent,
                  apiName: "Payroll:MonthlySalaryCalculationInformation",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.EidStock",
                  link: "/",
                  icon: "",
                  VoucherKindId: 7,
                  data: MonthlySalaryCalculationInformationComponent,
                  apiName: "Payroll:MonthlySalaryCalculationInformation",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.EidFee",
                  link: "/",
                  icon: "",
                  VoucherKindId: 8,
                  data: MonthlySalaryCalculationInformationComponent,
                  apiName: "Payroll:MonthlySalaryCalculationInformation",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.VacationSave",
                  link: "/",
                  icon: "",
                  VoucherKindId: 9,
                  data: MonthlySalaryCalculationInformationComponent,
                  apiName: "Payroll:VacationBuyInformation",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.VacationRedemption",
                  link: "/",
                  icon: "",
                  VoucherKindId: 10,
                  data: MonthlySalaryCalculationInformationComponent,
                  apiName: "Payroll:VacationBuyInformation",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ReserveYearsSservice",
                  link: "/",
                  icon: "",
                  VoucherKindId: 11,
                  data: MonthlySalaryCalculationInformationComponent,
                  apiName: "Payroll:EstablishmentTheReserveOfYearsOfService",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.RightsDocuments",
          icon: "icon-receipt-o",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.RightsDocuments",
              icon: "icon-receipt-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.IssuanceAccountingDocument",
                  link: "/",
                  icon: "",
                  data: HrmAccVoucherComponent,
                  apiName: "Payroll:HrmAccVoucherCode/GetAccVoucherInfo",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.RelationshipAccountsAgents",
                  link: "/",
                  icon: "",
                  data: HrmAccVoucherCodeComponent,
                  apiName: "Payroll:HrmAccVoucherCode",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ListIssuedDocuments",
                  link: "/",
                  icon: "",
                  data: HrmAccVoucherHeaderComponent,
                  apiName: "Payroll:HrmAccVoucherHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.Reports",
          icon: "icon-chart-bar-stacked",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.Reports",
              icon: "icon-chart-bar-stacked",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.RightsReview",
                  link: "/",
                  icon: "",
                  data: HrmReviewComponent,
                  apiName: "Payroll:HrmReview",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ComprehensiveRightsList",
                  link: "/",
                  icon: "",
                  data: PayMVPersReportComponent,
                  apiName: "Payroll:MonthlySalaryCalculationInformation/PayMVPersReport",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SalarySlip",
                  link: "/",
                  icon: "",
                  data: BillPayReportComponent,
                  apiName: "Payroll:MonthlySalaryCalculationInformation/BillPayReport",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.AssociationAgentsReports",
                  link: "/",
                  icon: "",
                  data: HrmMapReportListComponent,
                  apiName: "Payroll:HrmMapReport",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.InsuranceListReport",
                  link: "/",
                  icon: "",
                  data: HrmInsuranceReportComponent,
                  apiName: "Payroll:MonthlySalaryCalculationInformation/HrmInsuranceReport",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.MakingInsuranceDiskette",
                  link: "/",
                  icon: "",
                  data: HrmInsuranceDskComponent,
                  apiName: "Payroll:MonthlySalaryCalculationInformation/MakeInsDisk",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.TaxListReport",
                  link: "/",
                  icon: "",
                  data: HrmTaxReportComponent,
                  apiName: "Payroll:MonthlySalaryCalculationInformation/HrmTaxReport",
                  actionName: Permission.samePermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.MakingTaxBankDiskette",
                  link: "/",
                  icon: "",
                  data: HrmDiskFormatListComponent,
                  apiName: "Payroll:HrmDiskFormat",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: "ClientApp.Pages.PageMenu.InvSubTitle",
      icon: "icon-anbar2",
      children: [
        {
          title: "ClientApp.Pages.PageMenu.InvBasicInformation",
          icon: "icon-info-24px",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.Warehouse",
              link: "/",
              icon: "icon-home_work-o",
              data: WarehouseListComponent,
              apiName: "Inventory:Warehouse",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.UnitList",
              link: "/",
              icon: "icon-scale",
              data: UnitListComponent,
              apiName: "Inventory:Unit",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.GoodsGroup",
              link: "/",
              icon: "icon-cubes1",
              data: GoodsGroupListComponent,
              apiName: "Inventory:GoodsGroup",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.GoodsList",
              link: "/",
              icon: "icon-cube1",
              data: GoodsListComponent,
              apiName: "Inventory:Goods",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.InvVoucherKind",
              link: "/",
              icon: "icon-file-text1",
              data: InvVoucherKindListComponent,
              apiName: "Inventory:InvVoucherKind",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.InvBalance",
              link: "/",
              icon: "icon-file-text1",
              data: InvBalanceFormComponent,
              apiName: "Inventory:InvBalance",
              actionName: Permission.viewPermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.InvDailyOpration",
          icon: "icon-receipt-o",
          name: "Inventory:InvVoucherHeader",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.InvDailyOpration",
              icon: "icon-receipt-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.InvVoucherPricing",
                  link: "/",
                  icon: "account-outline",
                  data: InvVoucherPricingListComponent,
                  apiName: "Inventory:InvVoucherPricing",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.InvVoucherList",
                  link: "/",
                  icon: "account-outline",
                  data: InvVoucherListComponent,
                  apiName: "Inventory:InvVoucherHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.InvReview",
          icon: "icon-chart-bar-stacked",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.InventoryReview",
              link: "/",
              icon: "account-outline",
              data: InventoryReviewComponent,
              apiName: "Inventory:InventoryReview",
              actionName: Permission.viewPermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.GetInventoryBalancing",
              link: "/",
              //icon:'account-outline',
              data: InvBalanceListComponent,
              apiName: "Inventory:InvBalance/GetInventoryBalancing",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.GetReferenceVoucherByVoucherKind",
              link: "/",
              //icon:'account-outline',
              data: InvNoReferenceVoucherFormComponent,
              apiName: "Inventory:InvVoucherHeader/GetInvNoReferenceVoucher",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.WarehouseGoodsReport",
              link: "/",
              //icon:'account-outline',
              data: WarehouseGoodsReportComponent,
              apiName: "Inventory:Warehouse/WarehouseGoodsReport",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.UseMaterialsProduct",
              link: "/",
              //icon:'account-outline',
              data: MaterialUseInProductReportComponent,
              apiName: "Inventory:InventoryReview/GetMaterialUseInProductReport",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.PurchaseInvoiceReport",
              link: "/",
              //icon:'account-outline',
              data: PurchaseInvoiceReportComponent,
              apiName: "Inventory:PurchaseInvoiceReview/GetPurchaseInvoice",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.PriceChangeReportPurchase",
              link: "/",
              //icon:'account-outline',
              data: PriceChangeInPurchaseReportComponent,
              apiName: "Inventory:InventoryReview/GetPriceChangeInPurchaseReport",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.ReportingTotalPriceProductsBeforeSale",
              link: "/",
              //icon:'account-outline',
              data: FinishedPriceOfProductsBeforeSaleReportComponent,
              apiName: "Inventory:InventoryReview/GetFinishedPriceOfProductsBeforeSaleReport",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.ProductionCostReport",
              link: "/",
              //icon:'account-outline',
              data: CostPriceOfManufacturedProductsReportComponent,
              apiName: "Inventory:InventoryReview/GetCostPriceOfManufacturedProductsReport",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.GoodsTurnoverReport",
              link: "/",
              //icon:'account-outline',
              data: CirculationOfGoodsReportComponent,
              apiName: "Inventory:InventoryReview/GetCirculationOfGoodsReport",
              actionName: Permission.samePermission,
            },

            {
              title: "ClientApp.Pages.PageMenu.GeneralMonthlyFoodCassetteReport",
              link: "/",
              //icon:'account-outline',
              data: GeneralMonthlyFoodCostReportComponent,
              apiName: "Inventory:InventoryReview/GetGeneralMonthlyFoodCostReport",
              actionName: Permission.samePermission,
            },

            // {
            //   title: "ClientApp.Pages.PageMenu.NewDailyPurchaseInvoiceReport",
            //   link: "/",
            //   //icon:'account-outline',
            //   data: NewDailyPurchaseInvoiceReportComponent,
            //   apiName: "Inventory:InventoryReview/GetNewDailyPurchaseInvoiceReport",
            //   actionName: Permission.samePermission,
            // },
            // {
            //   title: "ClientApp.Pages.PageMenu.PurchasingDetailTeportTax",
            //   link: "/",
            //   //icon:'account-outline',
            //   data: PurchaseReportWithTaxComponent,
            //   apiName: "Inventory:InventoryReview/GetPurchaseReportWithTax",
            //   actionName: Permission.samePermission,
            // },
            {
              title: "ClientApp.Pages.PageMenu.NegativeProductBalanceReportDay",
              link: "/",
              //icon:'account-outline',
              data: NegativeRemainOfGoodsDalyReportComponent,
              apiName: "Inventory:InventoryReview/GetNegativeRemainOfGoodsDailyReport",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.CommodityIntermediaryReport",
              link: "/",
              //icon:'account-outline',
              data: AverageGoodsReportComponent,
              apiName: "Inventory:InventoryReview/GetAverageGoodsReport",
              actionName: Permission.samePermission,
            },
            {
              title: "ClientApp.Pages.PageMenu.CommodityIntermediaryReportCompare",
              link: "/",
              //icon:'account-outline',
              data: AverageGoodsReportComponent,
              apiName: "Inventory:InventoryReview/GetAverageGoodsReport",
              actionName: Permission.samePermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.TakingOfInventoryTitle",
          icon: "icon-anbar2",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.TakingOfInventoryHeader",
              link: "/",
              //icon:'icon-cubes1',
              data: TakingOfInventoryListComponent,
              apiName: "Inventory:TakingOfInventoryHeader",
              actionName: Permission.viewPermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.InventoryTransfer",
          icon: "icon-transfer",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.InventoryClosing",
              link: "/",
              //icon:'account-outline',
              data: InventoryClosingListComponent,
              apiName: "Inventory:InventoryClosing",
              actionName: Permission.viewPermission,
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.ProductConversionTitle",
          icon: "icon-dynamic_feed-F",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.ProductConversionTitle",
              icon: "icon-dynamic_feed-F",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.ProductConversionTitle",
                  link: "/",
                  icon: "icon-dynamic_feed-F",
                  data: ProductConversionListComponent,
                  apiName: "Inventory:ProductConversionHeader",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.ProductConversionStandardTitle",
                  link: "/",
                  icon: "icon-standard",
                  data: ProductConversionStandardListComponent,
                  apiName: "Inventory:ProductConversionStandardHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: "ClientApp.Pages.PageMenu.SellSubTitle",
      icon: "icon-bazargani",
      children: [
        {
          title: "ClientApp.Pages.PageMenu.SellBaseInformation",
          icon: "icon-info-24px",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.SellBaseInformation",
              icon: "icon-info-24px",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.SellCustomer",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: SellCustomerListComponent,
                  apiName: "SellCustomer:SellCustomer",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SellKind",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: SellKindListComponent,
                  apiName: "SellCustomer:SellKind",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SellCustomerGroup",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: SellCustomerGroupListComponent,
                  apiName: "SellCustomer:SellCustomerGroup",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.PriceListHeader",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: PriceListHeaderListComponent,
                  apiName: "SellCustomer:PriceListHeader",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SellVoucherKind",
                  //icon: { icon:'bank', pack:'sepidzicon'},
                  link: "/",
                  data: SellVoucherKindListComponent,
                  apiName: "Inventory:InvVoucherKind",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.SellDailyOpration",
          name: "SellCustomer:SellVoucherHeader",
          icon: "icon-receipt-o",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.SellDailyOpration",
              icon: "icon-receipt-o",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.DebtorCreditorNotices",
                  link: "/",
                  //icon:'account-outline',
                  data: DebtorCreditorNoticesHeaderListComponent,
                  apiName: "SellCustomer:DebtorCreditorNoticesHeader",
                  actionName: Permission.viewPermission,
                },
                {
                  title: "ClientApp.Pages.PageMenu.SellVoucherHeader",
                  link: "/",
                  //icon:'account-outline',
                  data: SellVoucherListComponent,
                  apiName: "SellCustomer:SellVoucherHeader",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
        {
          title: "ClientApp.Pages.PageMenu.SellReviewTitle",
          icon: "icon-chart-bar-stacked",
          children: [
            {
              title: "ClientApp.Pages.PageMenu.SellReviewTitle",
              icon: "icon-chart-bar-stacked",
              children: [
                {
                  title: "ClientApp.Pages.PageMenu.SellReview",
                  link: "/",
                  //icon:'account-outline',
                  data: SellCustomerReviewComponent,
                  apiName: "SellCustomer:SellCustomerReview",
                  actionName: Permission.viewPermission,
                },
              ],
            },
          ],
        },
      ],
    },

    {
      title: "ClientApp.Pages.PageMenu.Access",
      icon: "icon-dastresi",
      children: [
        {
          title: "ClientApp.Pages.PageMenu.Role",
          icon: "icon-groups-o",
          link: "/",
          data: RoleListComponent,
          apiName: "General:Role",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.UserList",
          icon: "icon-person_outline-F",
          link: "/",
          data: UserListComponent,
          apiName: "General:Authorization",
          actionName: Permission.viewPermission,
        },
        {
          title: "ClientApp.Pages.PageMenu.ResetPassword",
          icon: "icon-lock_open-o",
          link: "/",
          data: ResetPasswordListComponent,
          apiName: "General:Authorization",
          actionName: "ChangePassword",
        },
        {
          title: "ClientApp.Pages.PageMenu.UserReport",
          icon: "icon-lock_open-o",
          link: "/",
          data: UserSystemLogListComponent,
          apiName: "General:UserSystemLog",
          actionName: Permission.viewPermission,
        },
      ],
    },
  ];
}
